module.exports = __webpack_public_path__ + "media/images/icon-menu-b09dfaaf3bc20451f4c94af542a7dc26.svg";